import React, { useCallback } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { Typography } from 'components/uiKit/Typography'
import {
  BrandGoBack,
  BrandRichTextFontForms,
  BrandRichTextTypography,
} from 'services/Branding/components'
import { useElementFontCss, useElementFontValues } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { AccordionFormBrandType, AccordionBrandForms } from './accordionTypes'

const AccordionTypography: AccordionFormBrandType = ({ element, edited, device, setForm }) => {
  const { font } = element || {}
  const values = useElementFontValues('accordion', device, font)
  const styles = useElementFontCss('accordion', device, font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottomSpace gap sides>
        <BrandGoBack onClick={goBack}>
          <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        </BrandGoBack>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
      </Padding>
    </LayoutScroll>
  )
}

const FONTS_FORM_MAP: AccordionBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: AccordionTypography,
  ...BrandRichTextFontForms,
}

export default FONTS_FORM_MAP
